import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { ProgressCircle } from '@wds/progress-circle';
import { Typography } from '@wds/typography';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.KeywordGeneration.title',
    defaultMessage: 'Extracting keywords',
    description: '[Type: Header][Vis: med] - extracting keywords title'
  },
  time: {
    id: 'OpenEndedCoding.KeywordGeneration.time',
    defaultMessage: 'About 2 minutes',
    description: '[Type: Header][Vis: med] - time to extract keywords'
  },
  descriptionTheme: {
    id: 'OpenEndedCoding.KeywordGeneration.descriptionTheme',
    defaultMessage: 'Keywords are unique words associated with a theme.',
    description: '[Type: Header][Vis: med] - extracting keywords description'
  },
  descriptionReview: {
    id: 'OpenEndedCoding.KeywordGeneration.descriptionReview',
    defaultMessage: 'You’ll be able to review them in the next step.',
    description: '[Type: Header][Vis: med] - extracting keywords description'
  }
};
const KeywordGeneration = () => {
  return _jsxs(Box, {
    display: "flex",
    flexDirection: "column",
    flexJustify: "center",
    flexAlign: "center",
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(ProgressCircle, {
        continuous: true,
        size: "lg",
        valueText: "keywords"
      })
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "h4",
        variant: "sectionTitle",
        "data-testid": "KeywordGeneration__OECTitle",
        children: _jsx(T, {
          desc: COPY.title
        })
      })
    }), _jsx(Box, {
      mb: 6,
      children: _jsx(Typography, {
        component: "div",
        variant: "body",
        children: _jsx(T, {
          desc: COPY.time
        })
      })
    }), _jsx(Box, {
      children: _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: _jsx(T, {
          desc: COPY.descriptionTheme
        })
      })
    }), _jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: _jsx(T, {
          desc: COPY.descriptionReview
        })
      })
    })]
  });
};
export default KeywordGeneration;